import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function SelectionIntervalsGetObservable() {
  return ObservableFromFetch<string[]>("WorkforceRandomTest/GetSelectionIntervals")
}
